import React, { useEffect, useState } from "react";
import { Box, Typography, Divider } from "@mui/material";
import { useErrorBoundary } from "react-error-boundary";

import { useClientDetail } from "../../../../reactQuery/client";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../../../components/Loader";
import ClientLogo from "../../../../styles/svg/client-detail.svg";
import EditLogo from "../../../../styles/svg/edit-client.svg";
import { formatPhoneNumber } from "../../../../utils/helpers";
import LongFormDialog from "../../../../components/Dialog/LongFormDialog";
import EditClient from "../../components/EditClient";
import { useMediaQuery } from "react-responsive";
import "./ClientDetails.scss";
import InfoCard from "./InfoCard";
import GroupsIcon from "../../../../styles/svg/location-icon.svg";
import ContactIcon from "../../../../styles/svg/contact-person.svg";
import PricingIcon from "../../../../styles/svg/pricing-icon.svg";
import PricingClientIcon from "../../../../styles/svg/pricing-client-detail.svg";
import ContactClientIcon from "../../../../styles/svg/Phone.svg";

function ClientDetails() {
  const params = useParams();
  const isMobile = useMediaQuery({ maxWidth: "699px" });
  const redirect = useNavigate();
  const { showBoundary } = useErrorBoundary();
  const { responseData, isLoading, isError, error } = useClientDetail(
    params.clientId
  );

  useEffect(() => {
    if (error) {
      showBoundary(error);
    }
  }, [error]);

  const role = JSON.parse(localStorage.getItem("userData")).role;
  const [anchorEl, setAnchorEl] = useState(false);

  const handleClose = () => {
    setAnchorEl(false);
  };
  const handleClick = () => {
    setAnchorEl(true);
  };

  const editData = {
    user: {
      email: responseData?.email,
      name: responseData?.name,
      position: responseData?.position,
      phone_number: responseData?.phone_number,
    },
    company_name: responseData?.company_name,
    status: responseData?.status,
    client_id: params.clientId,
    zip_code: responseData?.zip_code,
    state: responseData?.state,
    city: responseData?.city,
    address: responseData?.address,
    street_address: responseData?.street_address,
    xrf_single_unit_testing_rate:
      responseData?.xrf_single_unit_testing_rate || null,
    xrf_volume_discount_rate: responseData?.xrf_volume_discount_rate || null,
  };
  return (
    <div>
      {anchorEl && (
        <LongFormDialog
          open={anchorEl}
          handleClose={handleClose}
          title={"Update Client"}
          btnTitle={"Confirm"}
        >
          <EditClient onClose={handleClose} data={editData} />
        </LongFormDialog>
      )}
      {isLoading && (
        <div className="client-detail-loader">
          <Loader color={"black"} />
        </div>
      )}
      {!isLoading && isError && (
        <div className="client-detail-loader">
          <p>{error?.response?.data?.message || "Error"}</p>
        </div>
      )}
      {!isLoading && !isError && (
        <div >
          {/* <div className="detail-action d-flex">
            <p
              className={"status-chip mr-1"}
              style={{ backgroundColor: "#808080", height: "28px" }}
            >
              {responseData?.status}
            </p>
            {role == "admin" && (
              <img
                src={EditLogo}
                onClick={handleClick}
                className="cursor-pointer"
              />
            )}
          </div> */}

          {/* New Card Layout */}
          <div className="client-info-cards">
            {/* Clients Card */}
            <InfoCard
              icon={ClientLogo}
              bgImage={GroupsIcon}
              data={{
                title: "Client",
                firstHeading: responseData?.company_name,
                secondaryFirst: `${responseData?.street_address || ""}${
                  responseData?.address ? `, ${responseData?.address}` : ""
                }`,
                secondarySec: `${responseData?.city || ""}${
                  responseData?.state ? `, ${responseData?.state}` : ""
                } ${responseData?.zip_code || ""}`,
              }}
            />

            <InfoCard
              icon={ContactClientIcon}
              bgImage={ContactIcon}
              data={{
                title: "Contact Person",
                firstHeading: responseData?.name,
                secondaryFirst: formatPhoneNumber(responseData?.phone_number),
                secondarySec: responseData?.email,
              }}
            />

            <InfoCard
              icon={PricingClientIcon}
              bgImage={PricingIcon}
              data={{
                title: "Pricing",
                firstHeading: "XRF",
                secondaryFirst: `Single Unit Testing: ${responseData?.xrf_single_unit_testing_rate || "NA"}`,
                secondarySec: `Volume Discount: ${responseData?.xrf_volume_discount_rate || "NA"}`,
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default ClientDetails;
